import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';

function CategoryPage() {
  const [categories, setCategories] = useState([]);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const fetchCategories = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await api.get('/categories/');
      setCategories(response.data);
    } catch (error) {
      toast.error('Não foi possível carregar as categorias.');
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  const handleAddCategory = async (e) => {
    e.preventDefault();
    if (!newCategoryName.trim()) {
      toast.error('O nome da categoria não pode ser vazio.');
      return;
    }

    const loadingToast = toast.loading('Adicionando...');
    try {
      await api.post('/categories/', { name: newCategoryName });
      setNewCategoryName(''); 
      fetchCategories(); 
      toast.dismiss(loadingToast);
      toast.success('Categoria adicionada!');
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error(error.response?.data?.error || 'Erro ao adicionar categoria.');
    }
  };

  return (
    <>
      <div className="mb-8">
        <h2 className="text-3xl font-bold font-manrope text-slate-900 tracking-tight mb-2">Gerenciar Categorias</h2>
        <p className="text-sm font-medium text-slate-500">Crie e organize as categorias para classificar suas transações com precisão.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="bg-white rounded-xl border border-slate-200 p-8 shadow-sm h-fit">
          <div className="flex items-center space-x-3 mb-6">
             <div className="w-10 h-10 rounded-lg bg-indigo-50 text-primary flex items-center justify-center">
                <span className="material-symbols-outlined">add_circle</span>
             </div>
             <h3 className="text-xl font-bold font-manrope text-slate-900">Nova Categoria</h3>
          </div>
          <form className="space-y-4" onSubmit={handleAddCategory}>
            <div>
              <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Nome da Categoria</label>
              <input
                type="text"
                value={newCategoryName}
                onChange={(e) => setNewCategoryName(e.target.value)}
                placeholder="Ex: Lazer, Educação..."
                required
                className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 text-sm font-medium text-slate-800 outline-none focus:ring-2 focus:ring-primary"
              />
            </div>
            <button type="submit" className="w-full flex items-center justify-center gap-2 bg-primary text-white font-bold py-3.5 px-4 rounded-xl shadow-md hover:bg-indigo-700 transition-colors mt-6">
              <span className="material-symbols-outlined text-lg">add</span>
              <span>Adicionar Categoria</span>
            </button>
          </form>
        </div>

        <div className="bg-white rounded-xl border border-slate-200 p-8 shadow-sm">
          <div className="flex items-center space-x-3 mb-6">
             <div className="w-10 h-10 rounded-lg bg-teal-50 text-teal-600 flex items-center justify-center">
                <span className="material-symbols-outlined">category</span>
             </div>
             <h3 className="text-xl font-bold font-manrope text-slate-900">Minhas Categorias</h3>
          </div>
          <div className="bg-slate-50 border border-slate-100 rounded-xl h-[400px] overflow-y-auto">
            <ul className="divide-y divide-slate-100">
              {isLoading ? (
                  <div className="p-8 text-center text-sm font-bold text-slate-400 flex items-center justify-center gap-2">
                     <span className="material-symbols-outlined animate-spin">refresh</span>
                     Aguarde...
                  </div>
              ) : categories.map(cat => (
                <li key={cat.id} className="p-4 flex items-center gap-4 hover:bg-slate-100 transition-colors cursor-default">
                  <div className="w-10 h-10 min-w-[40px] rounded-lg bg-white border border-slate-200 flex items-center justify-center text-slate-400 shadow-sm">
                    <span className="material-symbols-outlined text-[20px]">sell</span>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-slate-900">{cat.name}</h4>
                  </div>
                </li>
              ))}
              {!isLoading && categories.length === 0 && (
                 <div className="p-8 text-center text-sm font-medium text-slate-400">Nenhuma categoria encontrada.</div>
              )}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default CategoryPage;